var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.083,
    height: 11.083,
    viewBox: "0 0 11.083 11.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(0.042 0.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocks-_-Desktop-_-On-Card-_-File-upload-_-Add-files-_-Status-_-Default",
    "data-name": "Blocks-/-Desktop-/-On-Card-/-File-upload-/-Add-files-/-Status-/-Default",
    transform: "translate(-326 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocks-_-Desktop-_-File-upload-_-Add-files-_-Status-_-Default",
    "data-name": "Blocks-/-Desktop-/-File-upload-/-Add-files-/-Status-/-Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_content_clear_24px",
    "data-name": "icon/content/clear_24px",
    transform: "translate(82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M15.042,5.075,13.925,3.958,9.5,8.384,5.075,3.958,3.958,5.075,8.384,9.5,3.958,13.925l1.116,1.116L9.5,10.616l4.425,4.425,1.116-1.116L10.616,9.5Z",
    fill: "#14284b"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.f31f076181f3def51a01363f99a8616b.svg";
export { ForwardRef as ReactComponent };